import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styles from './Home.module.css';
import VideoSection from '../components/VideoSection';
import { getVideoName } from '../utils/environment';
import Modal from '../components/Modal';
import { createApiUrl } from '../utils/apiConfig';

const Home = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const getCookie = (name) => {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    };

    if (!getCookie('subscribed')) {
      setShowModal(true);
    }
  }, []);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;

    try {
      const response = await axios.post(createApiUrl('/api/subscribe'), { email });
      if (response.status === 200) {
        document.cookie = 'subscribed=true; max-age=604800; path=/';
        setShowModal(false);
        alert('Successfully subscribed');
      }
    } catch (error) {
      console.error('Subscription error:', error);
      alert('An error occurred while subscribing');
    }
  };

  return (
    <div className={styles.homeContainer}>
        <h1>Welcome to KBH Classroom!</h1>

        <div className={styles.intro}>
          <h4>Bringing Black History to Life for Children Everywhere</h4>
          <p>
            KBH Classroom is a dynamic video learning platform offering 40-minute video lessons focused on black history for KS2.
            We make black history education accessible, engaging, and fun for children. Our unique peer-to-peer teaching approach,
            led by our groundbreaking 8-year-old teacher (Raiyah from Kids Black History), empowers students to learn from one another,
            making the content relatable and inspiring. We believe every child deserves to learn about the rich contributions of black
            individuals and cultures to society—not just during Black History Month, but all year round.
          </p>
          <VideoSection
            videoName={getVideoName()}
          />
          <br />
          <p>
            Head over to view our <Link to="/kbh-curriculum">KBH Curriculum</Link> page to see how we link KBH Classroom to the KS2 curriculum.
          </p>
          <div className={`${styles['image-container']} ${styles['responsive-image']}`}>
            <img src="/img/under1para.png" alt="KBH Classroom Introduction" />
          </div>
        </div>

        <div className={styles.mission}>
          <h2>Our Mission</h2>
          <h4>Inspiring Minds, Empowering Futures</h4>
          <p>
            At KBH Classroom, our mission is simple: to ensure black history is integrated into school curriculums across the country.
            We're dedicated to educating children on the importance of black history, providing teachers with the tools and resources
            to make it a permanent part of classroom learning. Through storytelling, interactive lessons, and role models, we aim to
            foster cultural understanding and inspire the next generation of changemakers.
          </p>
          <div className={`${styles['image-container']} ${styles['responsive-image']}`}>
            <img src="/img/under2para.png" alt="KBH Classroom Mission" />
          </div>
        </div>

        <div className={styles['why-kbh']}>
          <h2>Why KBH Classroom?</h2>
          <h4>A Learning Gap That Needs to Be Filled</h4>
          <p>
            While diversity is a key talking point, black history is still largely underrepresented in the curriculum.
            KBH Classroom is here to change that. Our platform offers high-quality, engaging video lessons designed by educators
            and cultural historians to bring to life untold stories and celebrate the contributions of black figures throughout history.
            We provide teachers with everything they need to teach these lessons confidently, from structured lesson plans to
            peer-to-peer teaching opportunities.
          </p>
          <div className={`${styles['image-container']} ${styles['responsive-image']}`}>
            <img src="/img/under3para.png" alt="KBH Classroom Benefits" />
          </div>
          <p>Let's get black history into classrooms—one lesson at a time!</p>
        </div>

        <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
          <div className={styles['subscribe-modal']}>
            <span className={styles.close} onClick={() => setShowModal(false)}>&times;</span>
            <h2>Stay Connected – Unlock Exclusive Black History Resources!</h2>
            <p>Join our KBH Classroom community and be the first to access:</p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;✅ Exclusive lesson previews and new content updates<br />
              &nbsp;&nbsp;&nbsp;&nbsp;✅ Teaching resources to embed Black history across the curriculum<br />
              &nbsp;&nbsp;&nbsp;&nbsp;✅ Special offers and early-bird access to workshops<br />
              &nbsp;&nbsp;&nbsp;&nbsp;✅ Inspiring peer-led learning tools for your classroom<br />
            </p>
            <p>Don't miss out on empowering your students with diverse, engaging learning experiences—delivered straight to your inbox!</p>
            <form className={styles['subscribe-form']} onSubmit={handleSubscribe}>
              <div className="subscribe-form-group">
                <input type="email" id="email" name="email" required placeholder="Enter your email address" />
              </div>
              <button type="submit">Sign Up & Inspire your Classroom</button>
            </form>
          </div>
        </Modal>
    </div>
  );
};

export default Home; 